import type { PlaceAddress } from './places';
import apiService from './api';
import type { ApiResponse } from '../types/api';

export interface GeocodeResult {
  display_name: string;
  lat: number;
  lon: number;
  bbox: [number, number, number, number] | null;
  /** The address in parts, when it came from Google Places rather than the OpenStreetMap search. */
  place?: PlaceAddress;
}

class GeocodeService {
  async search(q: string): Promise<ApiResponse<GeocodeResult[]>> {
    return apiService.get<GeocodeResult[]>(`/geocode/search?q=${encodeURIComponent(q)}`);
  }
}

export default new GeocodeService();
